export type DeliveryClassification = "HARD" | "EDELIVERY";

export const DELIVERY_CLASSIFICATION_PROMPT = "How should this inventory be classified?";
export const DELIVERY_CLASSIFICATION_HINT =
	"*Mobile Transfer, Mobile QR, AXS Mobile ID, and E-Tickets should be classified as E-Delivery.";
export const DELIVERY_CLASSIFICATION_REQUIRED = "Please choose Hard Tickets or E-Delivery";

export const DELIVERY_CLASSIFICATION_OPTIONS: Array<{ value: DeliveryClassification; label: string }> = [
	{ value: "HARD", label: "Hard Tickets" },
	{ value: "EDELIVERY", label: "E-Delivery" },
];

const MOBILE_DELIVERY_TYPES = ["Mobile XFER", "Mobile Transfer", "Mobile QR", "AXS Mobile ID", "FLASH", "FLS"];

const collapseWhitespace = (value: string | null | undefined) => (value ?? "").replace(/[,;]/g, " ").trim().replace(/\s+/g, " ");

export const hasMobileDeliveryType = (notes: string | Array<string> | null | undefined): boolean => {
	const text = (Array.isArray(notes) ? notes.join(" ") : (notes ?? "")).toLowerCase();
	return MOBILE_DELIVERY_TYPES.some((type) => text.includes(type.toLowerCase()));
};

export const externalNotesChanged = (original: string | null | undefined, updated: string | null | undefined): boolean =>
	collapseWhitespace(original) !== collapseWhitespace(updated);
